import React from "react";
import { transform_languages } from "../../components/Transformation/Transformations";

function LeaderProfileImage({ currentLeader, t }) {
  return (
    <div className="flex flex-col items-center mt-20">
      <img
        src={
          currentLeader?.owner?.image
            ? `${currentLeader?.owner?.image}`
            : "https://res.cloudinary.com/do6t8sxgo/image/upload/v1724686661/Nobody_bao3i5.svg"
        }
        alt="UserImage"
        className="rounded-full border-solid border-[10px] border-[var(--brand)] w-[250px] h-[250px] md:w-[350px] md:h-[350px]"
      />
      <div className="text-3xl font-semibold mt-8">
        {currentLeader.owner.first_name + " " + currentLeader.owner.last_name}
      </div>
      <div className="text-xl font-normal">
        {t("leader_profile.teaching")}{" "}
        {t(transform_languages(currentLeader?.teaching_language))}
      </div>
    </div>
  );
}

export default LeaderProfileImage;
